import React from "react";
import { GRADE_SECTIONS } from "../../config/gradeSections";
import "./SectionTabs.css";

const SectionTabs = ({ gradeNumber, currentSection, onSectionChange }) => {
  const gradeInfo = GRADE_SECTIONS[gradeNumber];

  if (!gradeInfo) return null;

  return (
    <div className="section-tabs-container">
      <div className="section-tabs">
        {gradeInfo.sections.map((section) => (
          <button
            key={section.id}
            className={`section-tab ${currentSection === section.id ? "active" : ""}`}
            onClick={() => onSectionChange(section.id)}
          >
            <span className="tab-label">{section.label}</span>
            <span className="tab-label-si">{section.labelSi}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SectionTabs;
